export { default } from "./PlatformCard"
